var map = {
	"./die-cut.png": 2745,
	"./lamination.jpg": 9879,
	"./sheet-fed2.jpg": 6542,
	"./sheet-fed3.jfif": 8590,
	"./silk-screen1.jpg": 6123,
	"./web-offset.jpeg": 3307,
	"./web-offset.jpg": 9937,
	"./web-offset1.jpg": 8923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3883;